import React from 'react';
import { Users, UserCheck, UserX, TrendingUp } from "lucide-react";
import { Card, CardContent } from '../../tailwind/card';

export const OptInStats = () => {
  const stats = [
    { 
      label: "Total Contacts", 
      value: "12,450", 
      change: "+12% this month", 
      icon: Users,
      color: "text-blue-600 bg-blue-50 border-blue-100"
    },
    { 
      label: "Opted In", 
      value: "11,850", 
      change: "95.2% of total", 
      icon: UserCheck,
      color: "text-green-600 bg-green-50 border-green-100"
    },
    { 
      label: "Opted Out", 
      value: "600", 
      change: "4.8% of total", 
      icon: UserX,
      color: "text-red-600 bg-red-50 border-red-100"
    },
    { 
      label: "Growth Rate", 
      value: "+8.5%", 
      change: "vs last month", 
      icon: TrendingUp,
      color: "text-purple-600 bg-purple-50 border-purple-100"
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, i) => (
        <Card key={i} className="border-gray-200 shadow-sm">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500">{stat.label}</p>
                <h3 className="text-2xl font-bold text-gray-900 mt-2">{stat.value}</h3>
              </div>
              <div className={`p-3 rounded-xl border ${stat.color}`}>
                <stat.icon className="h-5 w-5" />
              </div>
            </div>
            <div className="mt-4 flex items-center text-xs">
              <span className="text-green-600 font-medium bg-green-50 px-2 py-0.5 rounded-full">
                {stat.change}
              </span>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};